import { render } from "./ItemLocations.vue?vue&type=template&id=434e411e&scoped=true"
import script from "./ItemLocations.vue?vue&type=script&lang=js"
export * from "./ItemLocations.vue?vue&type=script&lang=js"

import "./ItemLocations.vue?vue&type=style&index=0&id=434e411e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434e411e"]])

export default __exports__